<template>
  <section class="card_main">
    <section class="card_box" v-for="(cardItem,cardIndex) in cardList" :key="cardItem+cardIndex">
      <img
        @click.stop="delectCardItem(cardIndex)"
        class="delect_icon"
        v-if="cardIndex > 0 && come != 'xuqian'"
        src="../../../assets/images/delete_red.png"
      />
      <section class="mess_list">
        <section class="mess_list_item">
          <p class="list_item_left">
            车牌号
            <span>*</span>
          </p>
          <p
            :class="['list_item_right',!cardItem.cardNumber?'placeholder':'',come == 'xuqian'?'notclick':'']"
            @click="showKeyBoard(cardIndex)"
          >{{!cardItem.cardNumber?'请输入车牌号':cardItem.cardNumber}}</p>
          <!-- <input class="list_item_right" type="text" v-model="cardNumber" placeholder="请输入车牌号"> -->
        </section>
      </section>
      <h4 v-if="showUpLoadImg">
        上传照片
        <span v-if="mustImg != 2">*</span>
      </h4>
      <!-- {{mustImg != 2?"请务必上传真实有效的驾驶证正副页、行驶证正副页、驾驶员身份证正反面、爱车照片、公司证明等证明材料。":"上传真实有效的驾驶证正副页、行驶证正副页、驾驶员身份证正反面、爱车照片、公司证明等证明材料，可提高申请通过成功率哦~"}} -->
      <div
        v-if="showUpLoadImg"
        class="tips"
      >
      <span>1、首次申请时，请上传驾驶证、车辆照片、身份证(或园区工作证明)等信息；</span>
       <span> 2、续保申请时，只需上传身份证(或园区工作证明)即可；</span>
     </div>
      <div class="pic">
        <div class="addPic" v-for="(imgItem,imgIndex) in cardItem.fileList" :key="imgItem.path">
          <img class="video" :src="imgItem.path" @click="viewImage(imgItem,cardIndex,imgIndex)" />
          <img
            class="deleteFile"
            v-if="come != 'xuqian'"
            @click.stop="deleteFile(imgItem,cardIndex,imgIndex)"
            src="../../../assets/images/btn_clear.png"
          />
        </div>
        <div class="addPic" v-if="come != 'xuqian' && cardItem.fileList.length<9">
          <img class="addImg" src="../../../assets/images/repair/add.png" />
          <div class="item_center_inp" style="opacity:0;">
            <uploadimg-spaceup
              :multiple="true"
              :targetId="cardItem.targetId"
              :fileList="cardItem.fileList"
              moduleCode="TCP"
              @uploadImgEnd="uploadImgEnd"
              :index="cardIndex"
            ></uploadimg-spaceup>
          </div>
        </div>
      </div>
    </section>
    <!-- 添加车牌 -->
    <section
      class="add_card"
      v-if="come != 'add' && cardList.length < 3 && come != 'xuqian' &&serverType!=2 && parkingMess.id != 8 && parkingMess.id != 9"
    >
      <section class="add_card_main" @click="addCardNumber">
        <img :src="require(`../../../assets/images/btn_add_${$store.state.common.theme}.png`)" />
        <span>添加车牌</span>
      </section>
    </section>
    <!-- 键盘 -->
    <mt-popup v-model="showPopup" position="bottom" class="mint-popup">
      <key-board
        @sure="sureCardNumber"
        :cardIndex="cardIndex"
        :cardNumber="cardNumber"
        @close="showPopup = false"
      ></key-board>
    </mt-popup>
    <!-- 查看大图 -->
    <fade-animation>
      <common-gallary
        :imgs="arrImgs"
        :curIndex="curIndex"
        v-show="showGallary"
        @close="showGallary=false"
      ></common-gallary>
    </fade-animation>
  </section>
</template>

<script>
import KeyBoard from './keyBoard';
import uploadimgSpaceup from '../../../components/uploadImgSpaceup';
import CommonGallary from "../../../components/Gallary";
import FadeAnimation from "../../../components/FadeAnimation";
import { loadParkHeaderById, spaceUpPcHttp } from '../../../utils/api';
import util from '../../../utils/util';
export default {
  props: {
    showUpLoadImg: {
      type: Boolean,
      default: true
    },
    parkingMess: {
      type: Object,
      default() { return {} }
    },
    oldTarget: {
      type: Number,
      default: 0
    },
    come: {
      type: String,
      default: ''
    },
    mustImg: {//是否必传图片 1是，2否
      type: Number,
      default: 2
    },
    xuqianCardList: {
      type: Array,
      default() { return [] }
    },
    repeatCardList: {
      type: Array,
      default() { return [] }
    }
  },
  components: {
    KeyBoard,
    uploadimgSpaceup,
    CommonGallary,
    FadeAnimation
  },
  data() {
    return {
      cardNumber: '',
      cardIndex: 0,
      showPopup: false,
      arrImgs: [],
      curIndex: 0,
      serverType: 2,
      showGallary: false,
      hex_md5_return: '',
      timemap: '',
      selectCardIndex: '',//判断是点击哪个车牌
      removeSomeUrl: spaceUpPcHttp + '/syscfg/attachmentTerminal/removeSomeAttachment',
      searchFileUrl: spaceUpPcHttp + '/syscfg/attachmentTerminal/queryAttachmentListByOneData',
      // 车牌数据
      cardList: [
        {
          fileList: [],
          targetId: new Date().getTime(),
          cardNumber: ''
        }
      ]
    }
  },
  created() {
    let cardList = []
    if (this.xuqianCardList.length > 0) {
      this.resetSign()
      this.xuqianCardList.forEach((item, index) => {
        cardList.push({ fileList: [], targetId: 0, cardNumber: item.plateNo })
        // 获取车牌对应上传的图片
        this.getImgs(item, index)
      })
      this.cardList = cardList;
    }
    if (Object.keys(this.parkingMess).length > 0) {
      this.loadParkHeaderByIdAction();
    }
  },
  watch: {
    repeatCardList() {
      this.cardList = this.repeatCardList
    },
    parkingMess() {
      console.log("in parkingMess  change")
      if (this.parkingMess) {
        this.loadParkHeaderByIdAction();
      }
    }
  },
  methods: {
    change() {

    },
    loadParkHeaderByIdAction() {
      let params = {
        //  parkLotId:this.curData.parkLotId,
        id: this.parkingMess.id,
        url: "/parking/rstParkHeader/loadParkHeaderById"
      }
      loadParkHeaderById(params).then(res => {
        // loadParkHeaderByIdAction(params).then(res=>{
        console.log(res)
        if (res.res && res.res.code === 10000) {
          this.serverType = res.body.data.serverType

        }
      })

    },
    getImgs(item, index) {
      fetch(this.searchFileUrl + "?moduleCode=TCP&target=" + item.id + "&platform=SaasMobile" + "&timestamp=" + this.timemap + "&sign=" + this.hex_md5_return + "&companyId=" + this.$store.state.common.marketInfo.cityId, {
        method: 'get',
        headers: {
          "Access-channel": "saas_rst"
        },
      }).then(response => response.json()).then(res => {
        console.log(res)
        if (res.code === 1000) {
          this.cardList[index].fileList = res.data
        }
      })
    },
    resetSign() {
      // 公钥+私钥+时间戳+平台
      let gong = 'vanke2019spaceup009'
      let si = '009vanke2019spaceup001'
      this.timemap = new Date().getTime()
      let platfrom = 'SaasMobile'
      let str = gong + si + this.timemap + platfrom
      this.hex_md5_return = this.$md5(str)
    },
    viewImage(url, cardIndex, index) {
      this.cardList[cardIndex].fileList.forEach((item, i) => {
        // if(item.postfix.indexOf('image') > -1){
        this.$set(this.arrImgs, i, item.path)
        // }
      })
      this.curIndex = index
      this.showGallary = true
    },
    deleteFile(item, cardIndex, index) {
      let self = this;
      this.resetSign();
      util.showLoading('处理中...')
      fetch(self.removeSomeUrl, {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          "Access-channel": "saas_rst",
          "companyId": this.$store.state.common.marketInfo.cityId
        },
        body: JSON.stringify({
          'ids': item.id,
          'platform': 'SaasMobile',
          'timestamp': self.timemap,
          'sign': self.hex_md5_return,
          'companyId': this.$store.state.common.marketInfo.cityId
        })
      }).then(response => response.json()).then(res => {
        console.log(res)
        util.hideLoading()
        this.cardList[cardIndex].fileList.splice(index, 1)
      })
    },
    delectCardItem(index) {
      this.cardList.splice(index, 1)
      this.$emit("delectCardItem", { data: this.cardList, type: 'card' })
    },
    sureCardNumber(val) {
      this.showPopup = false;
      this.cardList[this.selectCardIndex].cardNumber = val
      this.$emit("inputChange", { data: this.cardList, type: 'card' })
    },
    showKeyBoard(cardIndex) {
      if (this.come == 'xuqian') { return false; }
      this.cardNumber = this.cardList[cardIndex].cardNumber;
      this.cardIndex = cardIndex;
      this.selectCardIndex = cardIndex;//判断是点击哪个车牌
      this.showPopup = true;
    },
    addCardNumber() {
      this.cardList.push(
        {
          fileList: [],
          targetId: new Date().getTime(),
          cardNumber: ''
        }
      )
    },
    uploadImgEnd(val) {
      let data = val.data;
      let index = val.index;
      this.cardList.forEach((item, i) => {
        if (i == index) {
          item.fileList.push({ path: data.url, id: data.id })
        }
      })
      this.$emit("inputChange", { data: this.cardList, type: 'card' })
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../../assets/css/common.less";
.card_box {
  background: #fff;
  padding: 0 28px;
  margin-bottom: 14px;
  position: relative;
  .delect_icon {
    width: 44px;
    height: 44px;
    position: absolute;
    top: 28px;
    right: 28px;
    z-index: 2;
  }
  .mess_list {
    background: #fff;
    .mess_list_item {
      position: relative;
      .flex();
      height: 100px;
      align-items: center;
      .list_item_left {
        width: 164px;
        font-size: 30px;
        color: rgba(51, 51, 51, 1);
        span {
          color: #fc3f56;
        }
      }
      .list_item_right {
        flex: 1;
        height: 100px;
        line-height: 100px;
        .borderB();
        font-size: 30px;
        color: #333;
      }
      .placeholder {
        color: #c9c9c9;
      }
      .notclick {
        opacity: 0.6;
      }
    }
  }
  h4 {
    font-size: 30px;
    color: rgba(51, 51, 51, 1);
    line-height: 42px;
    margin: 30px 0 10px;
    span {
      color: #fc3f56;
    }
  }
  .tips {
    font-size: 26px;
    color: rgba(153, 153, 153, 1);
    line-height: 36px;
    margin-bottom: 28px;
    span {
      margin-bottom: 10px;
      display: flex;
    }
  }
}
.pic {
  display: flex;
  flex-wrap: wrap;
  position: relative;
  .addPic {
    width: 160px;
    height: 160px;
    background: rgba(244, 244, 244, 1);
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    margin-bottom: 28px;
    margin-right: 28px;
    .video_icon {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 68px;
      height: 68px;
    }
    .video {
      width: 160px;
      height: 160px;
    }
    .addImg {
      width: 28px;
      height: 28px;
    }
    .item_center_inp {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
    }
    .file {
      position: absolute;
      width: 160px;
      height: 160px;
      opacity: 0;
    }
    .deleteFile {
      position: absolute;
      right: -25px;
      top: -25px;
      width: 50px;
      height: 50px;
    }
  }
}
// 添加车牌
.add_card {
  .flex();
  justify-content: flex-end;
  padding: 6px 20px 20px 0;
  .add_card_main {
    width: 200px;
    height: 68px;
    border-radius: 34px;
    background: #fff;
    .flex();
    justify-content: center;
    align-items: center;
    img {
      width: 32px;
      height: 32px;
      margin-right: 8px;
    }
    span {
      font-size: 28px;
      color: rgba(51, 51, 51, 1);
    }
  }
}
</style>
